import Vue from 'vue';
import Router from 'vue-router';

// Containers
import Full from '@/containers/Full';

// Views
import ErrorPage from '@/views/ErrorPage';
import Home from '@/views/Home';
import ManageListUser from '@/views/Manage/ListUser';
import ManageGroupUser from '@/views/Manage/GroupUser';
import ManageAudit from '@/views/Manage/Audit';
import BaseMap from '@/views/Manage/BaseMap';
import DataLayer from '@/views/Manage/DataLayer';
import Point from '@/views/Manage/Point';
import Photo from '@/views/Manage/Photo';
import GeneralInfo from '@/views/Manage/GeneralInfo';
import Tool from '@/views/Manage/Tool';
import Report from '@/views/Manage/Report';
import Config from '@/views/Manage/Config';
import Feedback from '@/views/Manage/Feedback';
import News from '@/views/Manage/News';

import DashBoardNew from '@/views/Public/DashboardNew';
import GeneralInfoPublic from '@/views/Public/GeneralInfo';
import ToolPublic from '@/views/Public/Tool';
import ReportPublic from '@/views/Public/Report';
import FeedbackPublic from '@/views/Public/Feedback';
import NewsPublic from '@/views/Public/News';
import NewsDetailPublic from '@/views/Public/NewsDetail';
import AllNewsPublic from '@/views/Public/AllNews';

// VueX store
import store from '@/store';

Vue.use(Router);

// Before enter functions
const ifAuthenticated = async (to, from, next) => {
    if (store.getters['auth/isAuthenticated']) {
        next();
        return;
    }
    next('/home');
};

export default new Router({
    linkActiveClass: 'open active',
    mode: 'history',
    routes: [
        {
            path: '*',
            name: 'ErrorPage',
            component: ErrorPage
        },
        {
            path: '/',
            redirect: '/home',
            component: Full,
            children: [
                {
                    path: 'home',
                    name: 'Home',
                    component: Home
                },
                {
                    path: 'dashboard',
                    name: 'DashBoard',
                    component: DashBoardNew
                },
                {
                    path: 'general-info',
                    name: 'Thông tin chung',
                    component: GeneralInfoPublic
                },
                {
                    path: 'tool',
                    name: 'Công cụ kỹ thuật',
                    component: ToolPublic
                },
                {
                    path: 'report',
                    name: 'Báo cáo đề tài',
                    component: ReportPublic
                },
                {
                    path: 'news',
                    name: 'routes.news',
                    redirect: '/news',
                    component: {
                        render(c) {
                            return c('router-view');
                        }
                    },
                    children: [
                        {
                            path: '',
                            name: 'ListNews',
                            component: NewsPublic
                        },
                        {
                            path: ':id(\\d+)',
                            name: 'NewsDetail',
                            component: NewsDetailPublic
                        }
                    ]
                },
                {
                    path: 'all-news',
                    name: 'AllNews',
                    component: AllNewsPublic
                },
                {
                    path: 'feedback',
                    name: 'Liên hệ',
                    component: FeedbackPublic
                },

                // System view
                {
                    path: 'system',
                    name: 'System',
                    redirect: '/system/feedback',
                    component: {
                        render(c) {
                            return c('router-view');
                        }
                    },
                    children: [
                        {
                            path: 'feedback',
                            name: 'Liên hệ',
                            component: Feedback,
                            beforeEnter: ifAuthenticated
                        },
                    ]
                },
                // User view
                {
                    path: 'user',
                    name: 'User',
                    redirect: '/user/group',
                    component: {
                        render(c) {
                            return c('router-view');
                        }
                    },
                    children: [
                        {
                            path: 'group',
                            name: 'Nhóm người dùng',
                            component: ManageGroupUser,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'user',
                            name: 'Người dùng',
                            component: ManageListUser,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'logs',
                            name: 'Audit',
                            component: ManageAudit,
                            beforeEnter: ifAuthenticated
                        },
                    ]
                },
                // Database view
                {
                    path: 'database',
                    name: 'Database',
                    redirect: '/database/base-map',
                    component: {
                        render(c) {
                            return c('router-view');
                        }
                    },
                    children: [
                        {
                            path: 'base-map',
                            name: 'Bản đồ nền',
                            component: BaseMap,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'data-layer',
                            name: 'Lớp dữ liệu',
                            component: DataLayer,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'point',
                            name: 'Điểm dữ liệu',
                            component: Point,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'photo',
                            name: 'Hình ảnh',
                            component: Photo,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'general-info',
                            name: 'Thông tin chung',
                            component: GeneralInfo,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'tool',
                            name: 'Công cụ kỹ thuật',
                            component: Tool,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'report',
                            name: 'Báo cáo đề tài',
                            component: Report,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'config',
                            name: 'Cấu hình',
                            component: Config,
                            beforeEnter: ifAuthenticated
                        },
                    ]
                },
                // News view
                {
                    path: 'news',
                    name: 'Manage News',
                    redirect: '/news/news',
                    component: {
                        render(c) {
                            return c('router-view');
                        }
                    },
                    children: [
                        {
                            path: 'news',
                            name: 'Tin tức',
                            component: News,
                            beforeEnter: ifAuthenticated
                        },
                    ]
                }
            ]
        }
    ]
});
